import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../../helpers';
import AclContextProvider from '../../../../../../Modules/Acl/Components/AclContextProvider';
import { AppContextProvider } from '../../../../../../Services/AppContext';
import { store } from '../../../../../../store/store';
import ManagerFinance from './ManagerFinance';
import { ManagerContextProvider } from '../../../../Services/ManagerContext';
import { parseBoolean } from '../../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-manager-finance',
	callback: ({ container, context, props }: any) => {
		const isSuperAdmin = parseBoolean(container.getAttribute('isSuperAdmin'));
		const workplaceId = container.getAttribute('workplaceId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<ManagerContextProvider
							isSuperAdmin={isSuperAdmin}
							workplaceId={workplaceId}>
							<ManagerFinance />
						</ManagerContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
